module.exports = __webpack_public_path__ + "images/emoji/bookmark.ecf00da39720b3cab5e5.png";